var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userSince)?_c('div',{staticClass:"seller-user-since"},[_c('span',{staticClass:"label tw-mr-1"},[_vm._v(_vm._s(_vm.isPlotClassified
        ? _vm.$t('agent in plot.gr since')
        : _vm.$t('dealer in car.gr since'))+":\n  ")]),_vm._v(" "),_c('span',{staticClass:"tw-font-bold tw-text-base"},[_vm._v("\n    "+_vm._s(_vm.formatedUserSince)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }